import React, {useEffect, useState} from 'react';
import {Button} from '../components/Button';
import {MainContantImage} from '../components/MainContantImage';
import { StoreSlider } from '../components/StoreSlider';
import {getBanners, getContents} from '../apis/contents';
import {CarharttBanner, Content, ScoreType, TargetType, UserInfo} from '../types/types';
import {Bridge} from '../plugins/bridge';
import { isMobile } from "react-device-detect";
import { VerificationPopupMain } from "../components/VerificationPopupMain";
// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/navigation/navigation.min.css';
import {CountDown} from "../components/CountDown";
// import Swiper core and required modules
import SwiperCore, {Navigation, Keyboard, Autoplay} from 'swiper/core';
import { BRAZE_EVENT } from '../constants/braze';
import { AIRBRIDGE_EVENT } from '../constants/airbridge';
import { TargetingGates } from '../plugins/targetingGates';
import { useLocation} from "react-router-dom";
import {scoreUp} from "../apis/score";
import dayjs from "dayjs";
import {useUserState} from "../context/UserContext";
import debug from '../utils/logging.js';
// install Swiper modules
import ReactPlayer from 'react-player';
// player modules


SwiperCore.use([Navigation, Keyboard, Autoplay]);

const HomePage = () => {
    const [banners, setBanners] = useState<CarharttBanner[]>();
    const [contents, setContents] = useState<Content[]>();
    const location = useLocation();
    const [verifiedPopup, setVerifiedPopup] = useState(false);
    const { isLoggedIn, userInfo } = useUserState();

    useEffect(() => {
        Bridge.sendAmplitude('main_home_page_viewed');
        Bridge.sendBraze(BRAZE_EVENT.MAIN_HOME_PAGE_VIEWED)
        Bridge.sendAirbridge(AIRBRIDGE_EVENT.homeScreen);
        getBanners('MAIN').then(r => {
            let data = r.data.payload.content;
            data.sort((a, b) => b.sort - a.sort);
            setBanners(data);
        }).catch(e => debug.log(e));
        getContents('CARHARTT').then(r => setContents(r.data.payload.content)).catch(e => debug.log(e));
        TargetingGates.sendHome();
    }, []);



    // useEffect(() => {
    //     const queryParams = new URLSearchParams(history.location.search);
    //     const backPage = queryParams.get('backPage');
    //
    //     if (backPage && isLoggedIn) {
    //         if (userInfo && userInfo.isVerified) {
    //             setVerifiedPopup(false);
    //         } else {
    //             setVerifiedPopup(true);
    //         }
    //     }
    // }, [history.location.search, isLoggedIn, userInfo]);

    useEffect(() => {
        if (!location.search.includes('backPage')) return;
        const lastClosedDate = getLastClosedDate();
        if (isLoggedIn && (!lastClosedDate || dayjs().diff(lastClosedDate, `${process.env.REACT_APP_MODE === 'development' ? 'seconds' : 'days'}`) >= (process.env.REACT_APP_MODE === 'development' ? 60 : 365))) {
            if (userInfo && userInfo.isVerified) {
                setVerifiedPopup(false);
            } else {
                setVerifiedPopup(true);
            }
        }
    }, [location.search, isLoggedIn, userInfo]);


    const setLastClosedDate = () => {
        const now = dayjs();
        localStorage.setItem('lastPopupClosedDate', now.toISOString());
    };
    const getLastClosedDate = () => {
        const lastClosedDate = localStorage.getItem('lastPopupClosedDate');
        return lastClosedDate ? dayjs(lastClosedDate) : null;
    };


    const handleClose = () => {
        setVerifiedPopup(false);
        setLastClosedDate();
    };


    const handleBannerClick = async (link: any, id: number) => {
        if (link) {
            window.open(link, '_self');
            await scoreUp(id, TargetType.CONTENT, ScoreType.VIEW);
        }
    };

    const handleButton1Click = async (banner: any, index: number) => {
        const eventName = getBannerEventName(index);
        await handleBannerClick(banner.buttonLink1, banner.id);
        Bridge.sendAmplitude(eventName, { content_id: banner.id });
    };
    const handleButton2Click = async (banner: any, index: number) => {
        const eventName = getBannerEventName(index);
        await handleBannerClick(banner.buttonLink2, banner.id);
        Bridge.sendAmplitude(eventName, { content_id: banner.id });
    };
    const getBannerEventName = (index: number): string => {
        switch (index) {
            case 0:
                return 'CH_first_main_banner_click';
            case 1:
                return 'CH_second_main_banner_click';
            case 2:
                return 'CH_third_main_banner_click';
            case 3:
                return 'CH_fourth_main_banner_click';
            default:
                return '';
        }
    };

    const handleContentClick = async (Data: any, index: number) => {
        if (Data.url) {
            window.open(`/${Data.url}`, '_parent');
            Bridge.sendAmplitude('main_content_clicked', { content_id: index, content_name: Data.text });
            await scoreUp(+Data.id, TargetType.CONTENT, ScoreType.VIEW);
        }
    };


    if (!banners || !contents) return null;
    return (
        <div className="-mx-4">
            <style>
                {`
            .swiper-pagination-bullet-active {
            background:rgba(255,255,255,0.8)  !important;
            }
          .swiper-button-next {
              width: 20% !important;
              height: 100% !important;
              top: 0 !important;
              opacity: 0;
          }
          .swiper-button-prev {
              width: 20% !important;
              height: 100% !important;
              top: 0 !important;
              opacity: 0;
          }
          `
                }
            </style>
            <VerificationPopupMain
                title="휴대폰 본인인증 진행"
                description="휴대폰 본인인증 후에 웍스아웃의 더 많은 혜택을 누려보세요."
                description2={`
            <div style="font-weight: 600">
                - 한정판 상품 응모 가능<br/>
                - 한정판 상품 선착 발매 시 구매 가능<br/>
                - 회원 전용 상품 발매 시 구매 가능
              </div>
            `}
                buttonText="휴대폰 본인인증"
                open={verifiedPopup}
                onClose={handleClose}
            />
            {isMobile &&  <CountDown />}
            <Swiper
                loop={true}
                navigation={true}
                pagination={true}
                keyboard={{
                    enabled: true
                }}
                autoplay={{
                    delay: 3000,
                }}
                watchOverflow={true}
            >
                {banners?.map((banner, index) => (
                    <SwiperSlide key={`${banner.id}-${index}`}>
                        <div key={banner.id}
                             className="bg-black relative w-full player-wrapper top_banner"
                             style={{height:`calc(100vh ${isMobile ? '- 200px':'- 55px'})`}}
                        >
                            <div className="text-white text-center absolute top_banner_con w-full h-full flex flex-col items-center md:justify-center justify-between md:gap-y-8 py-20 px-4 md:py-30 z-10">
                                <div/>
                                <h1 className="text-24 font-normal">
                                    {banner.title}
                                </h1>
                                <div className="flex md:flex-row flex-col gap-4 top_banner_b">
                                    {banner.buttonText1 && banner.buttonLink1 ? (
                                        <Button
                                            className="text-black w-40 h-13 bg_3e52bb text-white"
                                            onClick={() => handleButton1Click(banner, index)}>
                                            {banner.buttonText1}
                                        </Button>
                                    ) : (
                                        ''
                                    )}
                                    {banner.buttonText2 && banner.buttonLink2 ? (
                                        <Button
                                            className="text-black w-40 h-13 bg_3e52bb text-white"
                                            onClick={() => handleButton2Click(banner, index)}>
                                            {banner.buttonText2}
                                        </Button>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                            {isMobile ? (
                                    // 모바일
                                    // 모바일 배너영상
                                    banner.mobileImageUrl?.includes('.mp4') ? (
                                            <ReactPlayer
                                                url={banner.mobileImageUrl}
                                                playing={true}
                                                muted={true}
                                                loop={true}
                                                playsinline={true}
                                                controls={false}
                                            />
                                        ) : // PC 배너영상 && 모바일 배너 값 없음
                                        banner.imageUrl?.includes('.mp4') && !banner.mobileImageUrl ? (
                                            <ReactPlayer
                                                url={banner.imageUrl}
                                                playing={true}
                                                muted={true}
                                                loop={true}
                                                playsinline={true}
                                                controls={false}
                                            />
                                        ) : (
                                            // 영상배너 아님 && 모바일 배너, 없을 시 PC 배너
                                            <img
                                                src={
                                                    banner.mobileImageUrl
                                                        ? banner.mobileImageUrl
                                                        : banner.imageUrl
                                                }
                                                alt={banner.title}
                                                className={`w-full h-full object-cover ${
                                                    banner.mobileImageUrl ? '' : 'object-cover'
                                                }`}
                                            />
                                        )
                                ) : // PC
                                // 영상 배너
                                banner.imageUrl?.includes('.mp4') ? (
                                    <ReactPlayer
                                        url={banner.imageUrl}
                                        playing={true}
                                        muted={true}
                                        loop={true}
                                        playsinline={true}
                                        controls={false}
                                    />
                                ) : (
                                    // 이미지 배너
                                    <img
                                        src={banner.imageUrl}
                                        alt={banner.title}
                                        className="w-full h-full object-cover"
                                    />
                                )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className="grid md:grid-cols-3 grid-cols-1 mainContents1">
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 1)]}
                />
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 2)]}
                />
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 3)]}
                />
            </div>
            <div className="grid md:grid-cols-4  grid-cols-1 mainContents1">
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 4)]}
                />
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 5)]}
                />
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 6)]}
                />
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 7)]}
                />
            </div>

            {/*매장 admin*/}
            {/*<div className="grid md:grid-cols-2 grid-cols-1 mainContents2">*/}
            {/*    <MainContantImage*/}
            {/*        items={contents[contents.findIndex(item => item.sort === 8)]}*/}
            {/*    />*/}
            {/*    <MainContantImage*/}
            {/*        items={contents[contents.findIndex(item => item.sort === 9)]}*/}
            {/*    />*/}
            {/*</div>*/}

            <StoreSlider slidesPerView={2}/>

            <div className="grid md:grid-cols-3 grid-cols-1 mainContents2">
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 10)]}
                />
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 11)]}
                />
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 12)]}
                />
            </div>
            <div className="grid md:grid-cols-2 grid-cols-1 -mb-10 mainContents1">
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 13)]}
                />
                <MainContantImage
                    items={contents[contents.findIndex(item => item.sort === 14)]}
                />
            </div>
        </div>
    );
};

export default HomePage;
